export default "__VITE_ASSET__468494ca__"